import Image99X from './Assets/Logos/99x.png';
import ImageOzCodeLabs from './Assets/Logos/ozcodelabs.webp';
import OpenproviderLogo from './Assets/Logos/oplogo.png';
import ImageAirStudios from './Assets/Logos/airstudios.png';
import ImageStemUp from './Assets/Logos/stemup.png';
import ImageLeo from './Assets/Logos/leo.webp';

export const SOCIALS = [
    { name: 'LinkedIn', url: 'https://www.linkedin.com/in/isuru-ariyarathna-8a5404222' },
    { name: 'Github', url: 'https://github.com/Isw200' },
    { name: 'Twitter', url: 'https://twitter.com/Isuru2K00' },
    { name: 'Medium', url: 'https://medium.com/@isuruariyarathna2k00' },
    { name: 'Instagram', url: 'https://www.instagram.com/_isuru_ariyarathna_?igsh=MTNoanE1NHRyamwwOA%3D%3D&utm_source=qr' },
    { name: 'Facebook', url: 'https://m.facebook.com/profile.php?mibextid=LQQJ4d' },
];

export const STATS = [
    { value: '5+', label: 'Years building products' },
    { value: '20+', label: 'Shipped projects' },
    { value: '6', label: 'Countries served' },
];

export const MARQUEE = [
    'React', 'TypeScript', 'Node.js', 'React Native', 'Golang', 'Python',
    'PostgreSQL', 'Azure', 'AWS', 'Docker', 'Next.js', 'GraphQL',
];

export const EXPERTISE = [
    {
        icon: 'frontend',
        title: 'Frontend Development',
        description: 'Interfaces that stay fast and feel effortless at any scale.',
        items: ['HTML', 'CSS', 'JavaScript', 'ReactJS', 'NextJS', 'ElectronJS'],
    },
    {
        icon: 'backend',
        title: 'Backend Development',
        description: 'APIs and data layers designed for throughput and reliability.',
        items: ['NodeJS', 'Express', 'Spring Boot', 'MongoDB', 'MySQL', 'Firebase'],
    },
    {
        icon: 'mobile',
        title: 'Mobile App Development',
        description: 'Cross-platform and native apps shipped to real users.',
        items: ['React Native', 'Swift', 'iOS Development'],
    },
    {
        icon: 'cloud',
        title: 'Cloud & DevOps',
        description: 'Infrastructure, pipelines and releases that run themselves.',
        items: ['Microsoft Azure', 'Amazon Web Services', 'Docker', 'CI/CD'],
    },
    {
        icon: 'languages',
        title: 'Programming Languages',
        description: 'Picking the right tool instead of the familiar one.',
        items: ['JavaScript', 'Java', 'Python', 'C++', 'R', 'Kotlin'],
    },
    {
        icon: 'design',
        title: 'UI/UX & Design',
        description: 'From wireframe to polished, accessible product design.',
        items: ['Figma', 'Adobe XD', 'Photoshop', 'Illustrator'],
    },
];

export const EXPERIENCE = [
    {
        role: 'Software Engineer',
        company: 'Openprovider',
        period: 'March 2025 - Present',
        location: 'Rotterdam, Netherlands',
        website: 'https://www.openprovider.com',
        websiteLabel: 'openprovider.com',
        logo: OpenproviderLogo,
        description: 'Developing and maintaining web applications using React.js, NodeJS, PostgreSQL, Golang, and Python. I work closely with the design team to implement user-friendly interfaces and ensure a seamless user experience.',
        tags: ['Full Stack Development', 'ReactJS', 'NodeJS', 'PostgreSQL', 'Golang', 'Python'],
    },
    {
        role: 'Director of Technology',
        company: 'OzCodeLabs',
        period: 'August 2024 - 2025',
        location: 'Colombo, Sri Lanka',
        website: 'https://www.ozcodelabs.com.au/',
        websiteLabel: 'ozcodelabs.com.au',
        logo: ImageOzCodeLabs,
        description: 'Focused on software architecture and technology strategy, ensuring scalable, secure, and efficient solutions. I designed and oversaw system architecture for web and mobile applications using React.js, React Native, and Node.js, while managing Azure cloud infrastructure to support seamless deployment and performance.',
        tags: ['Software Architecture', 'ReactJS', 'NodeJS', 'React Native', 'Azure', 'DevOps'],
    },
    {
        role: 'Software Engineer Intern',
        company: '99X',
        period: 'June 2023 - July 2024',
        location: 'Colombo, Sri Lanka',
        website: 'https://99x.io/',
        websiteLabel: '99x.io',
        logo: Image99X,
        description: 'Built full-stack web and mobile applications using JavaScript, ReactJS, NodeJS, and React Native. Worked on AWS cloud services and serverless architecture, collaborating with cross-functional teams to define, design, and ship new features.',
        tags: ['JavaScript', 'ReactJS', 'NodeJS', 'Redux', 'React Native', 'AWS'],
    },
    {
        role: 'Director of Platforms',
        company: 'STEMUP Educational Foundation',
        period: 'June 2025 - June 2026',
        location: 'Colombo, Sri Lanka',
        website: 'https://stemup.lk/',
        websiteLabel: 'stemup.lk',
        logo: ImageStemUp,
        description: 'Designed and delivered multiple full stack web platforms for the organization using ReactJS, NodeJS, and Microsoft Azure.',
        tags: ['ReactJS', 'NodeJS', 'Redux', 'Microsoft Azure', 'Azure DevOps'],
    },
    {
        role: 'Frontend Developer',
        company: 'Airstudios',
        period: 'July 2022 - June 2023',
        location: 'Colombo, Sri Lanka',
        website: 'https://airstudios.lk/',
        websiteLabel: 'airstudios.lk',
        logo: ImageAirStudios,
        description: 'Developed responsive web applications using HTML, CSS, and JavaScript. Worked closely with the design team to implement UI/UX designs and with backend developers to integrate APIs and build new features.',
        tags: ['HTML', 'CSS', 'JavaScript'],
    },
    {
        role: 'Creative Director',
        company: 'Leo Club of IIT',
        period: '2021 - 2022',
        location: 'Colombo, Sri Lanka',
        website: null,
        websiteLabel: null,
        logo: ImageLeo,
        description: 'Led the creative team of the Leo Club of IIT. Designed promotional materials for events and campaigns, managed social media, and organized workshops and training sessions for club members.',
        tags: ['Figma', 'ReactJS', 'Adobe Photoshop', 'Adobe Illustrator', 'After Effects', 'Premiere Pro'],
    },
];

export const EDUCATION = [
    {
        qualification: 'BEng (Hons) Software Engineering - First Class Honours',
        institute: 'University of Westminster',
        period: '2021 - 2025',
        location: 'London, United Kingdom',
    },
    {
        qualification: 'Advanced Level',
        institute: 'Poramadulla Central College',
        period: '2017 - 2019',
        location: 'Rikillagaskada, Sri Lanka',
    },
];

export const PUBLICATIONS = [
    {
        title: 'Deploy-Ready IaC Generation Using Multi-Agent Systems for Cloud Deployments',
        publisher: 'IEEE Xplore',
        venue: 'ICBATS 2025 International Conference',
        location: 'Dubai, United Arab Emirates',
        year: '2025',
        brief: 'A multi-agent system approach for generating deploy-ready Infrastructure as Code, where specialised agents collaborate to produce, validate and refine cloud infrastructure definitions that can be provisioned without manual rework.',
        tags: ['Multi-Agent Systems', 'Infrastructure as Code', 'Cloud Deployment', 'LLMs', 'DevOps'],
        url: 'https://ieeexplore.ieee.org/document/11258273',
    },
];

export const REFERENCES = [
    {
        name: 'Prabhath Mannapperuma',
        positions: ['Partner Technology Strategist at Microsoft', 'Founder at STEMUP Educational Foundation'],
        email: 'prabhath@stemup.foundation',
        contact: '+9476 748 2482',
        image: 'https://i.ibb.co/ZJjG7bT/prabath.png',
    },
    {
        name: 'Pumudu A. Fernando',
        positions: ['Senior Lecturer at Informatics Institute of Technology (IIT)'],
        email: 'pumudu.f@iit.ac.lk',
        contact: '+9476 820 9742',
        image: 'https://i.ibb.co/ykBVdBk/pumudu.jpg',
    },
    {
        name: 'Kushan Bhareti',
        positions: ['Visiting Lecturer at Informatics Institute of Technology (IIT)', 'Vice President, Services at Inforwaves (Private) Limited'],
        email: 'kushan@inforwaves.com',
        contact: '+9476 781 4281',
        image: 'https://i.ibb.co/ZzGzS6k/kushan.png',
    },
];
